import { Creators as Address } from './reducer';
import { GET_ADDRESSES } from '@mockup/address.mockup';
import { apiHost, getAddressesRoute, addAddressRoute } from '@utils/constants';
import useRequest from '@utils/useRequest';

/**
 * Controls if data should be mocked or not
 */
const MOCK_DATA = false;

/**
 * Get a list of user addresses
 */
function getAddresses() {
  return dispatch => {
    useRequest({
      url: `${apiHost}${getAddressesRoute}`,
      mockup: MOCK_DATA ? GET_ADDRESSES : null,
      useSession: true,
    }).then(({ data }) => {
      dispatch(Address.getAll(data.addresses));
    });
  };
}

/**
 * Add a new billing address in the database
 *
 * @param {object} address The address object
 */
function addAddress(address) {
  return dispatch => {
    useRequest({
      url: `${apiHost}${addAddressRoute}`,
      method: 'post',
      //mockup: MOCK_DATA ? ADD_ADDRESS : null,
      data: { address },
    }).then(({ data }) => {
      dispatch(Address.add(data.address));
    });
  };
}

function updateAddress(address) {
  return dispatch => {
    dispatch(Address.updateAddress(address));
  };
}

export { getAddresses, addAddress, updateAddress };
